export function clampInt(n, min = 0) {
   const x = Number(n);
   if (!Number.isFinite(x)) return min;
   return Math.max(min, Math.trunc(x));
}

function readBooleanField(src, keys = []) {
   for (const key of keys) {
      const parts = String(key).split(".");
      let value = src;
      for (const part of parts) {
         value = value?.[part];
      }
      if (typeof value === "boolean") return value;
      if (typeof value === "number") return value === 1;
      const text = String(value ?? "")
         .trim()
         .toLowerCase();
      if (text === "true" || text === "1" || text === "yes" || text === "da") {
         return true;
      }
      if (text === "false" || text === "0" || text === "no" || text === "nu") {
         return false;
      }
   }
   return false;
}

function readAbsences(src) {
   const raw =
      src?.number_of_absences ??
      src?.numberOfAbsences ??
      src?.extras?.number_of_absences ??
      src?.profile?.number_of_absences ??
      0;
   return clampInt(raw, 0);
}

export function normStudentExtras(src) {
   const merged = {
      ...(src?.extras && typeof src.extras === "object" ? src.extras : {}),
      ...(src?.profile && typeof src.profile === "object" ? src.profile : {}),
      ...(src || {}),
   };

   return {
      medical_documents: readBooleanField(merged, [
         "medical_documents",
         "medicalDocuments",
      ]),
      individual_work: readBooleanField(merged, [
         "individual_work",
         "individualWork",
      ]),
      number_of_absences: readAbsences(merged),
   };
}

export function studentExtrasEqual(a, b) {
   const left = normStudentExtras(a);
   const right = normStudentExtras(b);
   return (
      left.medical_documents === right.medical_documents &&
      left.individual_work === right.individual_work &&
      left.number_of_absences === right.number_of_absences
   );
}

export function buildStudentExtrasPayload(form) {
   const extras = normStudentExtras(form);
   return {
      medical_documents: extras.medical_documents,
      individual_work: extras.individual_work,
      number_of_absences: extras.number_of_absences,
   };
}

export function mergeStudentRecord(...sources) {
   return sources.reduce((acc, src) => {
      if (!src || typeof src !== "object") return acc;
      return { ...acc, ...src };
   }, {});
}

export function unwrapUserResponse(raw) {
   if (!raw || typeof raw !== "object") return raw;
   return raw.data && typeof raw.data === "object" ? raw.data : raw;
}
